<template>
    <div ref="map" id="landing2" v-observe-visibility="{
  callback: visibilityChanged,
  once: true,
}" >
  <v-layout column wrap align-center justify-center>
    <v-flex>
      <transition name="fadeintro">
        <div v-if="showIntro" class="landing2-box">
          <h2 class="white--text">Melbourne Metro Rail Authority</h2>
          <p>John Holland Group was awarded the MMRA Early Works contact. ThinkSpatial is the supplier of survey and spatial services</p>
          <v-btn class="mx-2" fab small color="green" v-on:click="animateMap">
            <v-icon v-if="!pathGeoJson" dark>play_arrow</v-icon>
            <v-icon v-if="pathGeoJson && pathGeoJson.geometry.coordinates.length === 1" dark>play_arrow</v-icon>
            <v-icon v-if="pathGeoJson && pathGeoJson.geometry.coordinates.length > 1" dark>replay</v-icon>
          </v-btn>          
        </div>
      </transition>
      <transition name="fadeintro">
        <div v-if="!showIntro" class="landing2-box small-box">
          <v-btn class="mx-2" fab small color="green" v-on:click="animateMap">
            <v-icon dark>pause</v-icon>
          </v-btn>          
        </div>
      </transition>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import PublicLandingApi from '@/services/PublicLandingApi';
import Mapbox from 'mapbox-gl'
import * as turf from '@turf/turf'
export default {
  data () {
    return {
      showIntro: true,
      btnColor: 'green',
      landing2: null,
      actions: null,
      token: 'pk.eyJ1IjoiYWdhdXNzZW4iLCJhIjoiY2oydXp1dmg0MDAxeDJ2azJjOTM1Y202MCJ9.snYgaaG8eVpXPGw120O5Pg',
      animationId: undefined,
      loaded: null,
      progress: 0,
      pathGeoJson: null,
      flytoStation: 'Start',
      markerStations: null,
      popup: null,
      stations: {
        "type":"FeatureCollection",
        "features":[
          {
            "type":"Feature",
            "properties":{
              "station":"Start",
              "popupText":"Eastern Tunnel",
              "img":"eastern",
              "caption":"Testing"
            },
            "geometry":{
              "type":"Point",
              "coordinates":[144.99463696110928,-37.84167387886358]
            }
          },
          {
            "type":"Feature",
            "properties":{
              "station":"Domain",
              "popupText":"Domain Station",
              "img":"domain",
              "caption":"Testing"
            },
            "geometry":{
              "type":"Point",
              "coordinates":[144.97649175277442,-37.836528459798735]
            }
          },
          {
            "type":"Feature",
            "properties":{
              "station":"CBD South",
              "popupText":"CBD South Station",
              "img":"cbdsouth",
              "caption":"Testing"
            },
            "geometry":{
              "type":"Point",
              "coordinates":[144.96744125393855,-37.816825136457666]
            }
          },{
            "type":"Feature",
            "properties":{
              "station":"CBD North",
              "popupText":"CBD North Station",
              "img":"cbdnorth",
              "caption":"Testing"
            },
            "geometry":{
              "type":"Point",
              "coordinates":[144.963250556034,-37.807985933314484]
            }
          },
          {
            "type":"Feature",
            "properties":{
              "station":"Parkville",
              "popupText":"Parkville Station",
              "img":"parkville",
              "caption":"Testing"
            },
            "geometry":{
              "type":"Point",
              "coordinates":[144.95944723356604,-37.79995669699319]
            }
          },
          {
            "type":"Feature",
            "properties":{
              "station":"Arden",
              "popupText":"Arden Station",
              "img":"arden",
              "caption":"Testing"
            },
            "geometry":{
              "type":"Point",
              "coordinates":[144.9404658371749,-37.801470982790626]
            }
          },{
            "type":"Feature",
            "properties":{
              "station":"End",
              "popupText":"",
              "img":"arden2",
              "caption":"Testing"
            },
            "geometry":{
              "type":"Point",
              "coordinates":[144.9397731970557,-37.80138668843057]
            }
          }
        ]
      }
    }
  },
  methods: {
    visibilityChanged(){
      this.landing2.resize();
    },
    async getFeatures() {
      const response = await PublicLandingApi.heros('mmra')
      this.pathGeoJson = turf.lineString( JSON.parse(response.data.coordinates) )
      this.landing2.getSource('mmra').setData(this.pathGeoJson);
    },
    async animateMap(){
      this.showIntro = !this.showIntro
      this.setPopup(this.stations.features[0])
      if(!this.pathGeoJson) {
        this.getFeatures()
      }
      if (this.showIntro) {
        this.breakAnimation()
      } else {
        this.btnColor = 'red'
        this.loaded = performance.now()
        if(!this.pathGeoJson) {
          await this.getFeatures()
          this.animateLine()
        } else {
          this.animateLine()
        }
      }
    },
    breakAnimation(){
      if(this.animationId){
        setTimeout(function(){
          window.cancelAnimationFrame(this.animationId)
          this.animationId = undefined
        },0);
      }
      this.landing2.flyTo({
        center: [144.99463696110928, -37.841673878863581],
        zoom: 15,
        bearing: 0,
        speed: 0.8, // make the flying slow
        curve: 0.7, // change the speed at which it zooms out
        easing: function (t) {
          return t;
        }
      });
      this.showIntro = true
      this.btnColor = 'green'
      this.loaded = null;
      if(this.landing2.markerStations._popup.isOpen()) {
        this.landing2.markerStations.togglePopup();  
      }
    },
    setPopup(feature){
      this.landing2.popup.setHTML(
        '<h3>' + feature.properties.popupText + '</h3>'+
        '<div class="image">' +
          '<img src="' + require( 'assets/img/metro/'+feature.properties.img+'.jpg' ) + '" />'+
          // '<div class="caption">' + feature.properties.caption + '</div>'+
        '</div>', {
        closeButton: false,
        minWidth: 320
      });
      this.landing2.markerStations.setLngLat(feature.geometry.coordinates);
      if(!this.landing2.markerStations._popup.isOpen()) {
        this.landing2.markerStations.togglePopup();  
      }
    },
    animateLine(){
      let speed = 1
      let distance = turf.length(this.pathGeoJson, {units: 'kilometers'})
      this.progress = performance.now() - this.loaded
      let accumulatedDistance = ((this.progress / 3600) * speed)
      if(accumulatedDistance > distance) {
        this.breakAnimation()
      } else  {
        let point = turf.along(this.pathGeoJson, accumulatedDistance, {units: 'kilometers'})
        this.animationId = window.requestAnimationFrame(this.animateLine)
        let nearest = turf.nearest(point, this.stations)
        if(nearest.properties.station!= this.flytoStation) {
          this.setPopup(nearest)
          this.landing2.flyTo({
            center: nearest.geometry.coordinates,
            zoom: 15,
            pitch: 60,
            speed: 0.2, // make the flying slow
            curve: 0.7, // change the speed at which it zooms out
            easing: function (t) {
              return t;
            }
          });
          this.flytoStation = nearest.properties.station;   
        }        
      }
    }   
  },
  mounted(){
    this.$nextTick(function () {
      Mapbox.accessToken = this.token
      let map = new Mapbox.Map({
        container: 'landing2',
        style: 'mapbox://styles/mapbox/streets-v9',
        pitch: 45,
        center: [144.99463696110928, -37.841673878863581],
        zoom: 15,
        interactive: false
      });
      this.landing2 = map;
      map.on('load', function() {
        this.popup = new Mapbox.Popup()
        let el = document.createElement('div')
        this.markerStations = new Mapbox.Marker(el, { offset:[-25, -25] })
          .setLngLat([144.99463696110928, -37.841673878863581])
          .setPopup(this.popup)
          .addTo(map);
        map.addLayer({
          'id': '3d-buildings',
          'source': 'composite',
          'source-layer': 'building',
          'filter': ['==', 'extrude', 'true'],
          'type': 'fill-extrusion',
          'minzoom': 12,
          'paint': {
              'fill-extrusion-color': '#aaa',
              'fill-extrusion-height': {
                  'type': 'identity',
                  'property': 'height'
              },
              'fill-extrusion-base': {
                  'type': 'identity',
                  'property': 'min_height'
              },
              'fill-extrusion-opacity': .6
          }
        });
        map.addSource('mmra', {
          "type": "geojson",
          "data": {
            "type": "Feature",
            "geometry": {
              "type": "LineString",
              "coordinates": [[ 144.99463696110928, -37.841669476869981 ]]
            }
          }
        });
        map.addLayer({
          'id': 'mmra',
          'type': 'line',
          'source': 'mmra',
          'layout': {
            'line-join': 'round',
            'line-cap': 'round'
          },
          'paint': {
            'line-color': '#ed6498',
            'line-width': 20,
            'line-opacity': .8
          }
        });        
      })
    })
  }
}
</script>

<style>
  #landing2 {
    height: 100%;
    width: 100%;
  }

  .fadeintro-enter-active, .fadeintro-leave-active {
    transition: opacity .5s;
  }

  .fadeintro-enter, .fadeintro-leave-to {
    opacity: 0;
  }

  .landing2-box {
    position: absolute;
    left: 10%;
    bottom: 60px;
    z-index: 5;
    background-color: #f1592a;
    padding: 5px;
    text-align: center;
    line-height: 30px;
    padding-left: 10px;
    max-width: 250px;
  }

  .small-box {
    padding: 5px;
    border-radius: 35px;
  }

  .landing2-box p {
    color: #fff;
    box-sizing: border-box;
    line-height: 18px;
  }

  .mapboxgl-popup img {
    max-width: 200px;
  }

  .mapboxgl-popup {
    text-align: center;
  }
</style>